import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/mixins/toast' // toast封装
import './utils/mixins/http' // http封装
Vue.config.productionTip = false

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')